import * as React from 'react';
import Link from 'components/Link';
import MediaObject from 'components/MediaObject';
import EventTracking from 'lib/EventTracking';
import TextWithIcon from 'components/TextWithIcon';
import ModalTrigger from 'components/ModalTrigger';
import Box from 'components/Box';

import { coachingBillingViewPrefix } from 'coaching/components/CoachingBillingView/CoachingBillingView';

import './BankCard.scss';

export type Props = {
  brand?: string;
  lastFour?: string;
  updateModal?: React.ReactElement<any>;
  addModal?: React.ReactElement<any>;
  onUpdateBankCard?: () => void;
  onAddBankCard?: () => void;
  children?: React.ReactElement<any>;
};

export const ccBrandAbbrev = new Map([
  ['American Express', 'AMEX'],
  ['Visa', 'VISA'],
  ['MasterCard', 'MC'],
  ['Discover', 'DISC'],
]);

export default function BankCard({
  brand,
  lastFour,
  updateModal,
  addModal,
  onUpdateBankCard,
  onAddBankCard,
  children,
}: Props) {
  React.useEffect(() => {
    EventTracking.trackKey(
      `${coachingBillingViewPrefix}.coaching_billing_detail_card.update_payment.view`
    );
  }, []);
  return (
    <div className="BankCard">
      <Box
        textAlign="left"
        noShadow={true}
        noBorder={true}
        noColor={true}
        className="BankCard--info">
        <TextWithIcon
          center={true}
          className="BankCard--detail"
          icon="credit-card"
          iconSize="large"
          inline={true}
          size="large">
          <div className="BankCardDetailInfo">
            {brand && lastFour ? (
              <MediaObject
                className="BankCardDetailInfo--container"
                figure="right"
                data-test="detail-update-container">
                <span data-test="card-brand">
                  {ccBrandAbbrev.get(brand) ?? brand.toUpperCase()} •••• •••• •••• {lastFour}
                </span>
                {updateModal ? (
                  <ModalTrigger modal={updateModal}>
                    <Link
                      className="BankCardDetailInfoUpdate--action"
                      color="inherit"
                      weight="semibold">
                      Update card
                    </Link>
                  </ModalTrigger>
                ) : (
                  <Link
                    eventKey={`${coachingBillingViewPrefix}.coaching_billing_detail_card.update_payment.click`}
                    onClick={onUpdateBankCard}
                    className="BankCardDetailInfoUpdate--action"
                    color="inherit"
                    weight="semibold">
                    Update card
                  </Link>
                )}
              </MediaObject>
            ) : (
              <MediaObject
                className="BankCardDetailInfo--container"
                figure="right"
                data-test="detail-add-container">
                <span> No card on file </span>
                {addModal ? (
                  <ModalTrigger modal={addModal}>
                    <Link
                      className="BankCardDetailInfoUpdate--action"
                      color="inherit"
                      weight="semibold">
                      Add card
                    </Link>
                  </ModalTrigger>
                ) : (
                  <Link
                    onClick={onAddBankCard}
                    className="BankCardDetailInfoUpdate--action"
                    color="inherit"
                    weight="semibold">
                    Add card
                  </Link>
                )}
              </MediaObject>
            )}
          </div>
        </TextWithIcon>
        {children}
      </Box>
    </div>
  );
}
